<template>
  <v-dialog v-model="dialog" persistent max-width="708px" class="pa-0 pa-0 ma-0" style="background-color: #ffffff!important;">
    <v-card class="pa-0 ma-0" style="background-color: #ffffff00!important; z-index: -10;">
      <!-- <div class="pr-8" style=" background-color: transparent!important;"> -->
        <!-- <img class="cropped-image" style="position: absolute; z-index: -1; top: 0;" src="../../assets/images/fundo.png" width="850" alt="fundo decorativo" > -->
<!-- <div class="pr-8" style=" background-color: transparent!important; z-index:-1;"> -->
      <!-- <v-card-title class="pa-1" style="background-color: transparent!important;"> -->
        <a style="position: absolute; color: #FFFFFF; margin-left: 670px; margin-top:5px;  cursor: pointer;" href="#" id="btnFechar" alt="Clique aqui para fechar a janela" @click="fechar()"><v-icon color="#FFFFFF">mdi-close</v-icon></a>
        <!-- <v-col cols="12" class="pa-0 text-right" style=" margin-left: 40px"><v-btn style="margin-top: 5px; background-color: #FFFFFF;" icon @click="fechar()" color="primary" ><v-icon>mdi-close</v-icon></v-btn></v-col> -->
       <!-- <v-col cols="12" class="pa-0 pt-10 text-center"><span class="title">IMPORTANTE!</span></v-col> -->
      <!-- </v-card-title> -->
      <!-- <v-card-text class="pl-12 pr-12" style="background-color: transparent!important; font-family: 'Lato', sans-serif; font-size: 1.2em; color:#093956;"> -->
      <!-- <template>-->
        <!-- <div class="pl-12 pr-12" style="background-color: transparent!important; font-family: 'Lato', sans-serif; font-size: 1.2em; color:#093956;"> -->

 <!--       <p>Prezado(a) cliente,</p>
<p>Informamos que dia <b>12/09</b> faremos uma manutenção programada em nossa solução <b>Tradimus.</b></p>
<p>Essa é mais uma ação que faz parte dos nossos constantes investimentos na evolução das <b>nossas soluções</b>, para melhor <b>segurança</b>, <b>desempenho</b> e <b>estabilidade</b>.</p>
<v-alert dense text type="info" icon="fa fa-calendar" width="100%" color="#FFFFFF" class="mb-0" style=" background-color: #093956!important; z-index: 10;">
          <p style="text-align: left; padding-top:10px; margin-bottom: 5px;"><b>A aplicação ficará indisponível das 8h às 22h do dia 12/09, <br>sendo reestabelecida após a conclusão da ação. </b></p>
</v-alert>
<p style="padding-top:20px;">Nosso time estará à disposição para eventuais dúvidas e necessidade de orientações.</p>
<p>Agradecemos a compreensão!<br>
<b>Time Bionexo Tasy</b></p> -->
          <img src="../../assets/images/novo_canal_atendimento.jpg" width="708" alt="" style="margin:0; padding: 0;"/>
<!-- usemap="#image-map" -->
          <!-- <map name="image-map">
          <area target="_self" alt="Link para acessar o novo Suporte Tradimus." title="Clique aqui e acesse Já!" href="https://bionexo.atlassian.net/servicedesk/customer/portal/31" coords="258,242,16,279" shape="rect">
          <area target="_self" alt="teste2" title="teste2" href="#dois" coords="98,418,532,449" shape="rect">
          <area alt="Clique aqui para fechar a janela" title="Fechar" href="#" id="btnFechar" coords="621,30,28" shape="circle">
          </map> -->
        <!-- </div> -->
      <!-- </template> -->
      <!-- </v-card-text> -->
      <!-- <v-card-actions class="px-10">
        <v-btn
  color="primary"
  depressed
  small
>
<v-icon small class="pr-2">fa-download</v-icon>
<span>Download do manual</span>
</v-btn>
<v-spacer/>
<v-btn
  color="primary"
  depressed
  outlined
  small
>
<v-icon small  class="pr-2">fa-comment</v-icon>
<span>Abrir chamado</span>
</v-btn>
      </v-card-actions>-->
      <!-- </div> -->
      <!-- </div> -->
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    dialog: Boolean,
    fechar: Function
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
  },
  mounted () {
    // document.getElementById("btnFechar").addEventListener("click", ()=>{this.fechar()})
  },
  methods: {
    doCallback () {
      if (this.callback) {
        this.callback()
      }
      if (this.messageText) {
        this.messageForm(this.messageText)
        this.messageText = null
        this.$refs.messageTextForm.reset()
      }
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style>
.confirmMesgTxt {
  border-bottom: 1px solid #eee;
};
.mensagemHome {
   background-image: url("../../../public/images/image1.png");
        background-repeat: no-repeat;
        background-position: contain;

}
.fa-calendar:before {
    content: "\f133";
    vertical-align: baseline;
    padding: 20px 0 0 0;
}
.cropped-image {
  width: 850px;  /* Set the desired width of the cropped area */
  height: 390px; /* Set the desired height of the cropped area */
  object-fit: cover; /* This scales the image to cover the area, clipping the excess */
  object-position: top left; /* Centers the image within the container by default; use values like 'top', 'bottom', 'left', 'right', '20% 80%' to adjust the focus */
}
</style>
